const TrailerSalesPage = () => {
  return (
    <div>
      <h1>Trailer Sales Page</h1>
    </div>
  );
};

export default TrailerSalesPage;
